import React, { Component } from 'react'
import {isUndefined} from 'utils/common'; 
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertToRaw } from 'draft-js'
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';

import '../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export default class TextEditor extends Component {
    
    constructor(props) {
        super(props)
        
        var getInitialContent = () => {
            let contentBlock = htmlToDraft(isUndefined(this.props.value)? '': this.props.value);
            let contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            let editorState = EditorState.createWithContent(contentState);
            return editorState;
        }

        this.state = {
            editorState: getInitialContent(),
            hideToolbar: true
        }
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.getContent = this.getContent.bind(this);
        this.handlechange = this.handlechange.bind(this);
    }
    getContent(){
        let contentBlock = htmlToDraft(isUndefined(this.props.value)? '': this.props.value);
        let contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        let editorState = EditorState.createWithContent(contentState);
        return editorState;
    }
    componentDidUpdate(prevProps){
        if (this.props.value != prevProps.value) {
            this.setState({editorState: this.getContent()})
        }
    }
    handlechange(){
        let textHtml = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));
        textHtml = textHtml.replace('<p></p>','').trim()
        this.props.onChange({target: {type: 'custom', name:this.props.name, value:textHtml}},this.props.name, textHtml);
    }

    onEditorStateChange(editorState) {
        //const textHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));        
        this.setState({
            editorState,
        });       
        //this.props.onChange({target: {type: 'custom'}, name:this.props.name, value:textHtml},this.props.name, textHtml);
        // this.props.onChange({target: {type: 'custom'}, name:this.props.name, value:textHtml},this.props.name, textHtml);
    }

    render() {
        let classes ={toolbarHidden:{display: 'none'}, toolbar: {display:'flex'}};
        const { readOnly } = this.props;
        return <Editor placeholder={this.props.placeholder}
                    // toolbarStyle={this.state.hideToolbar ? classes.toolbarHidden : classes.toolbar}
                    // onFocus={() => {this.setState({hideToolbar: false});}}
                    // onBlur={() => {this.setState({hideToolbar: true});}}
                    onBlur={this.handlechange}
                    editorState = {this.state.editorState} 
                    onEditorStateChange = {this.onEditorStateChange}
                    wrapperClassName = "form-control"
                    toolbarClassName = "editorToolbar" 
                    readOnly={readOnly}
            />
    }
}


